shadow$provide[433] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 resampleBias;

vec4 resamplePadding(vec4 xyzw) {
  return xyzw + resampleBias;
}`;

};